<template>
    <div>
        <zm-row>
            <zm-button size="small" @click="showCreate()" class="btn-in-line" type="primary" v-if="hasPermission">Create Reassign</zm-button>
            <zm-button size="small" @click="fetchData(true)" plain class="btn-in-line">show all</zm-button>
            <zm-select size="small" v-model="channelId" @change="fetchData"
            placeholder="Search by channel" class="channel-select" clearable filterable>
                <zm-option v-for="item in channelList" :key="item.channelId"
                :label="item.channelName" :value="item.channelId"></zm-option>
            </zm-select>
        </zm-row>
        <zm-table :data="list" v-loading="loading" :init-displayed-column="initDisplayedColumn">
            <zm-table-column prop="name" label="name"></zm-table-column>
            <zm-table-column prop="channelName" label="channelName"></zm-table-column>
            <zm-table-column prop="topicUrl" label="topicUrl"></zm-table-column>
            <zm-table-column prop="reassignmentJson" label="reassignmentJson" show-overflow-tooltip></zm-table-column>
            <zm-table-column prop="status" label="status" width="120px"></zm-table-column>
            <zm-table-column prop="modifiedTime" label="modifiedTime" :formatter="setTime"></zm-table-column>
            <zm-table-column prop="operate" width="150px">
                <template slot-scope="scope">
                    <zm-button type="icon" icon="zm-icon-delete" @click="deleteReassign(scope.row.id)"></zm-button>
                    <zm-dropdown class="btn-contain" style="margin-left: 10px;" trigger="click" @command="handleCommand">
                        <zm-button type="icon" icon="zm-icon-more" class="btn-contain"></zm-button>
                        <zm-dropdown-menu slot="dropdown">
                            <zm-dropdown-item :command="{command: 'verifyReassign', param: scope.row.id}">
                                Verify Reassign
                            </zm-dropdown-item>
                            <zm-dropdown-item :command="{command: 'executeReassign', param: scope.row.id}">
                                Execute Reassign
                            </zm-dropdown-item>
                        </zm-dropdown-menu>
                    </zm-dropdown>
                </template>
            </zm-table-column>
        </zm-table>
        <zm-dialog :title="!form.id ? 'Create Reassign' : 'Edit Reassign'" :visible.sync="visible">
            <zm-form :model="form" :rules="rules" label-position="left" ref="form" label-width="180px">
                <zm-form-item prop="name">
                    <div slot="label">
                        <tip label="name" id="manage-reassign-name"></tip>
                    </div>
                    <zm-input size="small" v-model="form.name"></zm-input>
                </zm-form-item>
                <zm-form-item prop="channelId">
                    <div slot="label">
                        <tip label="channelId" id="manage-reassign-channelId"></tip>
                    </div>
                    <zm-select size="small" v-model="form.channelId" @change="fetchTopic" style="width: 100%">
                        <zm-option v-for="item in channelList" :key="item.channelId"
                        :label="item.channelName" :value="item.channelId"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="topicUrl">
                    <div slot="label">
                        <tip label="topicUrl" id="manage-reassign-topicUrl"></tip>
                    </div>
                    <zm-select size="small" v-model="form.topicUrl" filterable clearable style="width: 100%">
                        <zm-option v-for="item in topicList" :key="item" :value="item" :label="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="increaseFactorNum">
                    <div slot="label">
                        <tip label="increaseFactorNum" id="manage-reassign-increaseFactorNum"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.increaseFactorNum" :min="1"></zm-input-number>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Save</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listCluster, getClusterTopics } from '@/api/kafkaManage'
import { listReassign, createReassign, deleteReassign, verifyReassign, executeReassign, listReassignByChannel } from '@/api/manage'
import tip from 'components/ToolTip/index'
export default {
    name: 'manageReassign',
    components: {
        tip
    },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            initDisplayedColumn: {
                key: 'reassign',
                props: ['name', 'channelName', 'topicUrl', 'reassignmentJson', 'status', 'modifiedTime', 'operate']
            },
            loading: false,
            list: [],
            channelId: '',
            channelList: [],
            topicList: [],
            visible: false,
            form: {
                channelId: '',
                topicUrl: '',
                increaseFactorNum: '',
                id: '',
                name: ''
            },
            rules: {
                name: [
                    { required: true, message: 'please enter name', trigger: 'blur' }
                ],
                channelId: [
                    { required: true, message: 'please enter channelId', trigger: 'blur' }
                ],
                topicUrl: [
                    { required: true, message: 'please enter topicUrl', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.fetchData()
        this.fetchChannel()
        localStorage.params = ''
        localStorage.path = this.$route.path
    },
    methods: {
        setTime (row, column, cellValue, index) {
            return new Date(parseInt(cellValue)).toLocaleString()
        },
        fetchData (showAll) {
            if (showAll === true) {
                this.channelId = ''
            }
            if (!this.channelId) {
                this.loading = true
                listReassign().then(response => {
                    this.loading = false
                    this.list = response
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.loading = true
                listReassignByChannel(this.channelId).then(response => {
                    this.loading = false
                    this.list = response
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        fetchChannel () {
            listCluster().then(res => {
                this.channelList = res
            })
        },
        fetchTopic () {
            if (this.form.channelId) {
                getClusterTopics(this.form.channelId).then(res => {
                    this.topicList = res.topicUrls
                })
            } else {
                this.topicList = []
            }
        },
        deleteReassign (id) {
            this.$confirm('This will delete the reassign. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteReassign(id).then(response => {
                    this.fetchData()
                    this.$message({
                        message: 'Delete success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        verifyReassign (id) {
            this.$confirm('This will verify the reassign. Continue?', 'Warning', {
                confirmButtonText: 'Verify',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                verifyReassign(id).then(response => {
                    this.loading = false
                    this.$message({
                        message: 'Verify success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Verify canceled'
                })
            })
        },
        executeReassign (id) {
            this.$prompt('Input zookeeperConnectAddress of execution (optional)', 'Execute Reassign', {
                confirmButtonText: 'Execute',
                cancelButtonText: 'Cancel'
            }).then(({ value }) => {
                this.loading = true
                executeReassign(id, value).then(res => {
                    this.loading = false
                    // this.$message.success('Execute success')
                    this.$message.info({
                        // title: 'Reassign Message',
                        showClose: true,
                        message: res.reassignMsg,
                        duration: 0
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.$message.info('Execute canceled')
            })
        },
        showCreate () {
            this.form.id = ''
            this.form.name = ''
            this.form.channelId = ''
            this.form.topicUrl = ''
            this.form.increaseFactorNum = ''
            this.visible = true
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    createReassign(this.form).then(response => {
                        this.fetchData()
                        this.$message({
                            message: 'Create success!',
                            type: 'success'
                        })
                        this.visible = false
                        this.$refs.form.resetFields()
                    }).catch(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        },
        handleCommand (command) {
            if (command.command === 'verifyReassign') {
                this.verifyReassign(command.param)
            } else if (command.command === 'executeReassign') {
                this.executeReassign(command.param)
            }
        }
    }
}
</script>
<style scoped>
.channel-select {
    float: right;
    margin: 10px;
    width: 20%;
}
</style>
<style>
.zm-notification__content {
    word-break: break-word;
}
</style>
